import React from 'react';
import { useTranslation } from 'react-i18next';
import XtramModal, { XtramButton, xtramStyles } from '../Widgets/XtramModal/XtramModal';
import styles from './BankXtram.module.scss';

const KeyboardShortcutsDialog = ({ open, onClose, direction }) => {
    const { t } = useTranslation();

    const shortcuts = [
        { keys: ['\u2191', '\u2193'], description: t('KbdGuideNavigateRows') },
        { keys: ['\u2190', '\u2192'], description: t('KbdGuideSwitchPanels') },
        { keys: ['Space'], description: t('KbdGuideToggleSelect') },
        { keys: ['Shift', 'Space'], description: t('KbdGuideRangeSelect') },
        { keys: ['Shift', '\u2191/\u2193'], description: t('KbdGuideRangeExtend') },
        { keys: ['Shift', 'Click'], description: t('KbdGuideShiftClick') },
        { keys: ['F5'], description: t('KbdGuideReconcile') },
        { keys: ['F5'], description: t('KbdGuideReconcileDifference') },
        { keys: ['F6'], description: t('KbdGuidePerRowEntries') },
        { keys: ['Enter'], description: t('KbdGuideDialogNextField') },
        { keys: ['Ctrl', 'Enter'], description: t('KbdGuideConfirmDialog') },
        { keys: ['/'], description: t('KbdGuideSearch') },
        { keys: ['Esc'], description: t('KbdGuideExitSearch') },
        { keys: ['?'], description: t('KbdGuideOpenGuide') },
    ];

    return (
        <XtramModal
            open={open}
            onClose={onClose}
            title={t('KbdGuideTitle')}
            direction={direction}
            footer={<XtramButton onClick={onClose}>{t('Close')}</XtramButton>}
        >
            <p className={xtramStyles.muted}>{t('KbdGuideIntro')}</p>
            <div className={styles.shortcuts}>
                {shortcuts.map((shortcut, index) => (
                    <div key={index} className={styles.shortcutRow}>
                        <span className={styles.shortcutKeys} dir="ltr">
                            {shortcut.keys.map((key, keyIndex) => (
                                <React.Fragment key={keyIndex}>
                                    <kbd className={styles.keyCap}>{key}</kbd>
                                    {keyIndex < shortcut.keys.length - 1 && <span className={styles.keyPlus}>+</span>}
                                </React.Fragment>
                            ))}
                        </span>
                        <span>{shortcut.description}</span>
                    </div>
                ))}
            </div>
        </XtramModal>
    );
};

export default KeyboardShortcutsDialog;
